var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-wrap-bg"},[_c('EditCorrectionForm',{ref:"correction-edit-form",attrs:{"emit-submit":"","is-edit":""},on:{"updated":_vm.correctionUpdated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }